import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import icons from '../../helpers/Icons';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const VehicleDetailsGeneral = (props) => {
  const { t, fields, } = props;
  const classes = useStyles();

  const renderIcon = (field) => {
    if (field.key === 'vin') {
      return icons(`${field.key}`, classes.icon)
    }
    const suffix = field.positiveValues.includes(field.value) ? 'positive' : 'negative'
    return icons(`${field.key}_${suffix}`, classes.icon)
  }

  const renderDescription = (field) => {
    if (field.key === 'service_booklet') {
      return <div className={classes.iconDescription}><p>{t(`details_condition.${field.key}.${field.value}`)}</p></div>
    }
    if (field.key === 'vin') {
      return <div className={classes.iconDescription}><p>VIN: {field.value}</p></div>
    }
    const suffix = field.positiveValues.includes(field.value) ? 'positive' : 'negative'
    return <div className={classes.iconDescription}><p>{t(`details_condition.${field.key}_${suffix}`)}</p></div>
  }

  return (
    <div>
      <div className={classes.wrapper}>
        <div className={classes.iconsContainer}>
          {fields.map((field) => (
            field.value !== null && <React.Fragment key={field.key}>
               {renderIcon(field)}
               {renderDescription(field)}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  icon: {
    marginTop: '2rem',
    width: '25px',
    fontSize: '25px',
  },
  iconsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingBottom: '4em',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconDescription: {
    display: 'flex',
    paddingLeft: '0.7em',
    width: '91%',
    marginTop: '2rem',
    alignItems: 'center',
    fontSize: '16px',
  },
  '@media (max-width: 993px)': {
    iconDescription: {
      width: '94%',
      fontSize: '15px',
    },
    icon: {
      width: '22px',
      fontSize: '22px',
    },
  },
  '@media (max-width: 400px)': {
    iconDescription: {
      width: '91%',
    },
  },
  '@media (max-width: 330px)': {
    iconDescription: {
      width: '90%',
    },
  },
});


VehicleDetailsGeneral.propTypes = {
  t: PropTypes.func.isRequired,
  fields: PropTypes.array.isRequired,
};

export default withScopedTranslations('offer_details')(VehicleDetailsGeneral)
